<template>
  <div class="question row">
    <div class="col-6">
      <homework-container :question="question"></homework-container>
      <div class="row">
        <div v-for="(item, index) in question.questions" :key="index" class="col-md-12">
          <div>
            <div class="answer-title mb-1">
              <div v-html="formatBrTagText(item.title)"></div>
            </div>
            <div v-if="typeView === 'view-result'">
              <div v-if="item.student_answer" class="bold mb-2">Bài làm của học viên:</div>
              <audio v-if="item.student_answer" controls preload="metadata" ref="video-log">
                <source :src="getAudioByField(item.student_answer)" type="audio/ogg">
              </audio>
            </div>
            <div v-else class="d-flex align-items-center">
              <el-button type="success" icon="el-icon-microphone">Record Now</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="point" class="col-6">
      <div class="result-panel">
        <div class="result-panel__assessment">
          <SpeakingAssessment
            :evaluation-status="speakingEvaluation.evaluationStatus"
            :not-meet-reason="speakingEvaluation.notMeetReason"
            :not-meet-description="speakingEvaluation.notMeetDescription"
            :disable="true"
          />
        </div>

        <template v-if="speakingEvaluation.evaluationStatus === 'pass'">
          <div class="result-panel__skills">
            <div v-for="(item, index) in LIST_SKILL_AUDIO_VIDEO" :key="item.key || index" class="result-panel__skill-item">
              <ViewSkillOfSpeaking
                :current-homework="viewHomework"
                :type-skill="item"
                :evaluation-status="speakingEvaluation.evaluationStatus"
              />
            </div>
          </div>
        </template>

        <div class="total-score-box">
          <div class="total-score-box__label-wrap">
            <span class="total-score-box__label">Điểm toàn bài</span>
          </div>
          <el-input disabled class="total-score-box__input" :value="point.totalPoint" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeworkContainer from './homework-container.vue'
import { NameSkill, NameSkillOld } from '@/core/option/selectScore'
import SpeakingAssessment from '@/view/pages/classes/mark-homework/components/SpeakingAssessment.vue'
import ViewSkillOfSpeaking from '@/view/pages/classes/mark-homework/components/ViewSkillOfSpeaking.vue'
import { LIST_SKILL_AUDIO_VIDEO } from '@/view/pages/classes/mark-homework/constant'

export default {
  name: 'record-audio',
  components: {
    SpeakingAssessment: SpeakingAssessment,
    ViewSkillOfSpeaking: ViewSkillOfSpeaking,
    homeworkContainer: homeworkContainer
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    },
    typeView: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      LIST_SKILL_AUDIO_VIDEO: LIST_SKILL_AUDIO_VIDEO,
      speakingEvaluation: {
        evaluationStatus: 'pass',
        notMeetReason: '',
        notMeetDescription: ''
      },
      detailedComments: [],
      overallComments: [],
      point: {}
    }
  },
  computed: {
    viewHomework() {
      const homework = {}

      this.LIST_SKILL_AUDIO_VIDEO.forEach((skill) => {
        const pointItem = (this.point?.skillPoints || []).find((item) => item.nameSkill === skill.name)
        homework[skill.key] = {
          score: pointItem?.pointSkill ?? 0,
          commentOverall: this.getCommentBySkillType(this.overallComments, skill.key),
          detailedComment: this.getCommentBySkillType(this.detailedComments, skill.key)
        }
      })

      return homework
    }
  },
  mounted() {
    let outComes = this.question?.outComes || {}
    const detailOutcome = this.parseMaybeJson(outComes?.detail_outcome, {})
    const comments = this.parseMaybeJson(outComes?.comments, [])
    const scoreDetail = this.parseMaybeJson(outComes?.score_detail, {})
    const overallComments =
      this.parseMaybeJson(detailOutcome?.overallEvaluation, null) ||
      this.parseMaybeJson(detailOutcome?.comments, [])

    this.detailedComments = Array.isArray(comments) ? comments : []
    this.overallComments = Array.isArray(overallComments) ? overallComments : []
    this.speakingEvaluation = this.getSpeakingEvaluation(detailOutcome)

    let skillPoints = this.detailedComments.map((comment) => {
      let key = Object.keys(comment || {}).find((item) => item !== 'type')
      if (!key) {
        return null
      }
      let quantityComments = this.detailedComments?.length
      return {
        nameSkill: quantityComments === 4 ? NameSkill?.get(key) : NameSkillOld.get(key),
        pointSkill: scoreDetail?.[key],
        commentSkill: comment[key]
      }
    }).filter(Boolean)

    if (skillPoints.length && skillPoints.length !== this.LIST_SKILL_AUDIO_VIDEO.length) {
      skillPoints = this.changeDataOld(skillPoints)
    }

    if (!skillPoints.length) {
      skillPoints = this.LIST_SKILL_AUDIO_VIDEO.map((skill) => {
        return {
          nameSkill: skill.name,
          pointSkill: scoreDetail?.[skill.key] ?? 0,
          commentSkill: ''
        }
      })
    }

    this.point = {
      totalPoint: outComes?.score,
      skillPoints: skillPoints
    }
  },
  methods: {
    parseMaybeJson(value, fallback) {
      if (value === null || value === undefined || value === '') {
        return fallback
      }

      if (typeof value === 'string') {
        try {
          return JSON.parse(value)
        } catch (error) {
          return fallback
        }
      }

      return value
    },
    getSpeakingEvaluation(detailOutcome) {
      const normalized = this.parseMaybeJson(detailOutcome, {})
      const evaluationStatus = normalized?.skill_assessment == '0' ? 'fail' : 'pass'

      return {
        evaluationStatus: evaluationStatus,
        notMeetReason: normalized?.disqualification_reason || '',
        notMeetDescription: normalized?.disqualification_reason_detail || ''
      }
    },
    getCommentBySkillType(commentsArray, skillType) {
      if (!Array.isArray(commentsArray) || !commentsArray.length) {
        return {
          content: '',
          type: 'text'
        }
      }

      const commentObj = commentsArray.find((comment) => {
        return comment && Object.prototype.hasOwnProperty.call(comment, skillType)
      })

      if (!commentObj) {
        return {
          content: '',
          type: 'text'
        }
      }

      return {
        content: commentObj?.[skillType] || '',
        type: commentObj?.type || 'text'
      }
    },
    formatBrTagText(value) {
      return value ? value.replace(/(\r\n|\n\r|\r|\n)/g, '<br>') : ''
    },
    getAudioByField(string) {
      let url = string.split('://')
      if (url.length > 1) {
        return string
      }
      return 'https://' + string
    },
    changeDataOld(valueOld) {
      let newValue = ['Fluency & Coherence', 'Lexical Resource', 'Grammatical range & Accuracy', 'Pronunciation'].map((name) => {
        return {
          nameSkill: name,
          pointSkill: 0,
          commentSkill: ''
        }
      })
      valueOld.forEach((value) => {
        switch (value.nameSkill) {
          case 'Fluency':
          case 'Coherence': {
            let fluencyCoherence = newValue[0]
            newValue[0] = {
              ...fluencyCoherence,
              pointSkill: fluencyCoherence.pointSkill + value.pointSkill / 2,
              commentSkill: fluencyCoherence.commentSkill + value.commentSkill
            }
            break
          }
          case 'Vocabulary Range':
          case 'Vocabulary Accuracy': {
            let lexicalResource = newValue[1]
            newValue[1] = {
              ...lexicalResource,
              pointSkill: lexicalResource.pointSkill + value.pointSkill / 2,
              commentSkill: lexicalResource.commentSkill + value.commentSkill
            }
            break
          }
          case 'Grammatical Range':
          case 'Grammatical Accuracy': {
            let grammaticalRangeAccuracy = newValue[2]
            newValue[2] = {
              ...grammaticalRangeAccuracy,
              pointSkill: grammaticalRangeAccuracy.pointSkill / 2 + value.pointSkill,
              commentSkill: grammaticalRangeAccuracy.commentSkill + value.commentSkill
            }
            break
          }
          case 'Pronunciation': {
            let pronunciation = newValue[3]
            newValue[3] = {
              ...pronunciation,
              pointSkill: pronunciation.pointSkill + value.pointSkill / 2,
              commentSkill: pronunciation.commentSkill + value.commentSkill
            }
            break
          }
        }
      })
      return newValue
    }
  }
}
</script>

<style scoped>
.comment-essay {
  width: 100%;
  height: auto;
  background: #fbf5ff;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 20px;
  font-size: 14px;
}

.result-panel {
  padding: 22px;
  border: 1px solid #dde3f0;
  border-radius: 22px;
  background: linear-gradient(180deg, #f8faff 0%, #f2f5fb 100%);
}

.result-panel__assessment {
  padding: 6px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
}

.result-panel__skills {
  margin-top: 22px;
}

.result-panel__skill-item + .result-panel__skill-item {
  margin-top: 18px;
}

.total-score-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 22px;
  padding: 18px 20px;
  border: 1px solid #d8dfef;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(34, 62, 110, 0.06);
}

.total-score-box__label-wrap {
  display: flex;
  flex-direction: column;
}

.total-score-box__label {
  font-size: 18px;
  font-weight: 700;
  color: #1d2b53;
}


.total-score-box__input {
  width: 140px;
}

.total-score-box__input /deep/ .el-input__inner {
  height: 46px;
  border-radius: 14px;
  border-color: #cfd8ec;
  background: #f7f9fd;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: #2450b8;
}

@media (max-width: 991.98px) {
  .result-panel {
    margin-top: 20px;
  }

  .total-score-box {
    align-items: flex-start;
    flex-direction: column;
  }

  .total-score-box__input {
    width: 100%;
  }
}
</style>
